module.exports = __webpack_public_path__ + "static/media/poison_oak.5581a9e2.jpg";